<!--
 * @Author: zhouhuan
 * @Description: 管道流向相关功能
-->
<template>
  <div class="position-absolute pipeFlowDirection">
    <!-- 模型进度条 -->
    <PlayerProgress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showProgress"
    ></PlayerProgress>
  </div>
</template>

<script>
import DynamicManageService from '@/services/dynamicManageService'
import {
  setFlowDirectionFun,
  closeOrShowFlowDirectionFun,
} from '@/views/dynamicManage/js/renderUVActions'
const PlayerProgress = () => {
  return import('@/components/model/PlayerProgress')
}
export default {
  components: {
    PlayerProgress,
  },
  name: 'PipeFlowDirection',
  props: ['documentId', 'player'],
  data() {
    return {
      loadType: '',
      loadPercentage: 0,
      showProgress: false,
      allConvertNodeList: [], // 加载过的流向节点node与item对应的映射表
      currentMixer: null, // 动画混合器
      pipeFlowDataList: [], // 全部管道流向数据
      currentShowFlowDatas: [], // 当前选中的过滤后的数据集合
    }
  },
  created() {
    // this.getPipeFlowList()
  },
  watch: {
    async documentId(val) {
      window.player = this.player
      if (val) {
        this.currentShowFlowDatas = []
        this.allConvertNodeList = []
        // await this.getPipeFlowList()
      }
    },
  },
  methods: {
    // 获取管道流向
    async getPipeFlowList() {
      // 判断是否配置管道流向的开关，如果配置了在请求数据
      const res = await DynamicManageService.getPipeFlowList({
        documentId: this.documentId,
        pageNo: 1,
        pageSize: 9999,
      })
      if (res && res.code === 0 && res.data) {
        this.pipeFlowDataList = res.data
      }
    },
    // 加载或者关闭指定管道流向集合的方法
    async operaPipeFlow(pipeList, flag) {
      if (flag) {
        // 显示有流向的管道流向
        let currentPipeFlow = null
        let currentImagePathName = null
        for (let a = 0; a < pipeList.length; a++) {
          currentPipeFlow = _.cloneDeep(pipeList[a])
          if (currentPipeFlow.flowDirection && currentPipeFlow.fluidTypeImagePathDesc) {
            currentImagePathName = currentPipeFlow.fluidTypeImagePathDesc
          } else {
            currentImagePathName = currentPipeFlow.fluidTypeImagePathAsc
          }
          const matImageName = _.last(currentImagePathName.split('/'))
          const matUrl = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/dynamic/pipeFlow/${matImageName}`
          const isExists = await this.player.Native.File.exists(matUrl)
          if (!isExists) {
            await this.player.Native.File.EventDownloadProcessChanged.connect(
              this.matDownloadProcess
            )
            await this.player.Native.File.EventDownloadFinish.connect(
              this.downloadEngineerFileMsg(currentPipeFlow)
            )
            this.player.Native.File.downloadFile(
              matUrl,
              'GET',
              `${currentEnv.VUE_APP_PLANT_SERVER}${currentImagePathName}`,
              {},
              (res) => {
                // 代表创建下载任务成功
                if (res) {
                  this.loadType = '下载流体类型文件...'
                  this.showProgress = true
                } else {
                  this.$message.warning('下载文件失败')
                }
              }
            )
          } else {
            await setFlowDirectionFun(
              this.player,
              matUrl,
              currentPipeFlow,
              this.allConvertNodeList,
              this.currentMixer
            )
          }
        }
      } else {
        // 关闭有流向的管道流向
        for (let a = 0; a < pipeList.length; a++) {
          let currentItem = pipeList[a]
          await closeOrShowFlowDirectionFun(
            this.player,
            currentItem.playerModelPipleName,
            this.allConvertNodeList,
            false
          )
        }
      }
    },
    async todoOperation(val) {
      console.log(val, '---val----', this.allConvertNodeList)
      let selectObj = null
      let currentSelectFlow = null
      let topItemObj = null
      switch (val) {
        case 'xslx':
          {
            // 获取选中的节点及其子节点
            selectObj = await this.player.Native.ModelTree.getSelectedItem()
            // 判断是否选择节点
            if (_.isEmpty(selectObj)) {
              this.$message({
                message: '选择需要显示流向的对象!',
                type: 'warning',
              })
              return
            }
            currentSelectFlow = await this.filterDataBySelecteItem(selectObj)
            this.currentShowFlowDatas.push(...currentSelectFlow)
            console.log(currentSelectFlow, this.currentShowFlowDatas, '12131313123')
            //加载管道流向
            await this.operaPipeFlow(currentSelectFlow, true)
          }
          break
        case 'gblx':
          {
            // 获取选中的节点及其子节点
            selectObj = await this.player.Native.ModelTree.getSelectedItem()
            if (_.isEmpty(selectObj)) {
              this.$message({
                message: '选择需要关闭流向的对象!',
                type: 'warning',
              })
              return
            }
            currentSelectFlow = await this.filterDataBySelecteItem(selectObj)
            // 找出当前选中有流向节点数据 在  上一次选中数组中索引，然后选出存在的，然后进行关闭流向操作，然后从上一次选中数组中除去
            let curCloseFlowData = []
            for (let i = 0; i < currentSelectFlow.length; i++) {
              let item = currentSelectFlow[i]
              let index = _.indexOf(
                _.map(this.currentShowFlowDatas, 'playerModelPipleName'),
                item.playerModelPipleName
              )
              if (index >= 0) {
                this.currentShowFlowDatas.splice(index, 1)
                curCloseFlowData.push(item)
              }
            }
            // 关闭管道流向
            await this.operaPipeFlow(curCloseFlowData, false)
          }
          break
        case 'qbxs':
          {
            await this.operaPipeFlow(this.pipeFlowDataList, true)
            this.currentShowFlowDatas = _.cloneDeep(this.pipeFlowDataList)
          }
          break
        case 'qbgb':
          {
            this.operaPipeFlow(this.pipeFlowDataList, false)
            this.currentShowFlowDatas = []
          }
          break
        case 'ycwlx':
          {
            topItemObj = await this.player.Native.ModelTree.getRootItems()
            // 影藏所有节点
            _.forEach(topItemObj, (val) => {
              this.player.Native.ModelTree.setItemVisible(val.item, false)
            })
            // 将有流向的节点显示设置流向
            _.forEach(this.currentShowFlowDatas, async (val) => {
              await closeOrShowFlowDirectionFun(
                this.player,
                val.playerModelPipleName,
                this.allConvertNodeList,
                true
              )
            })
          }
          break
        case 'xswlx':
          {
            topItemObj = await this.player.Native.ModelTree.getRootItems()
            // 显示所有节点
            _.forEach(topItemObj, (val) => {
              this.player.Native.ModelTree.setItemVisible(val.item, true)
            })
            // 将全部有流向的节点恢复，然后设置当前要显示流向的节点设置流向
            await this.operaPipeFlow(this.pipeFlowDataList, false) // 此处先还原，是为了避免影响显示流向里面获取item的方法
            _.forEach(this.currentShowFlowDatas, async (val) => {
              await closeOrShowFlowDirectionFun(
                this.player,
                val.playerModelPipleName,
                this.allConvertNodeList,
                true
              )
            })
          }
          break
        default:
          break
      }
    },
    // 通过节点向上递归，获取所有父辈节点
    async getAllFathersItem(parentItem) {
      let fathersItemLists = []
      let parentInfo = await PlayerUtils.call(this.player.Native.ModelTree.getItemInfo, parentItem)
      fathersItemLists.push(parentInfo.item)
      if (parentInfo.selfId) {
        // 等于0则为最外面的一层
        while (parentInfo.selfId !== 1) {
          parentInfo = await PlayerUtils.call(
            this.player.Native.ModelTree.getItemInfo,
            parentInfo.parentItem
          )
          fathersItemLists.push(parentInfo.item)
        }
      }
      return fathersItemLists
    },
    // 通过item节点获取下面的子孙节点，然后根据流向清单过滤出有流向的管道流向数据
    async filterDataBySelecteItem(selectObj) {
      const node = await this.player.Native.ModelTree.convertToNode(selectObj.item, false, false) // 将PR节点转化成Node
      await this.player.Native.NodeProxy.setNodeVisible(node, false) // 设置node节点影藏
      await this.player.Native.ModelTree.setItemVisible(selectObj.item, true) // 设置模型树节点显示
      // 依据流向清单过滤符合要求的选中节点
      const nodeChildren = (await this.player.Native.NodeProxy.getNodeChildrenRecursion(node)) || []
      const currentList = _.map(nodeChildren, (item) => {
        return item.name || ''
      })
      let currentSelectFlowData = _.filter(this.pipeFlowDataList, (val) => {
        return _.includes([...currentList, selectObj.name], val.playerModelPipleName)
      })
      return currentSelectFlowData
    },
    // 流体类型图片下载进度
    matDownloadProcess(file, bytes, bytesTotal) {
      if (bytesTotal > 0) {
        this.loadPercentage = (bytes / bytesTotal) * 100
      }
    },
    // 流体类型文件下载完成
    downloadEngineerFileMsg(currentPipeFlow) {
      const fun = async (file, err) => {
        this.loadPercentage = 0
        this.showProgress = false
        setFlowDirectionFun(
          this.player,
          file,
          currentPipeFlow,
          this.allConvertNodeList,
          this.currentMixer
        )
        this.player.Native.File.EventDownloadProcessChanged.disconnect(this.matDownloadProcess)
        this.player.Native.File.EventDownloadFinish.disconnect(fun)
      }
      return fun
    },
  },
}
</script>
<style lang="scss" scoped>

.pipeFlowDirection {
  top: 50%;
  left: 50%;
  z-index: 999;
}

</style>
